import BackupService from '../services/backup'
import { isPersistedTourStorageKey } from '../tours/storage'

/**
 * Clears user/session localStorage on logout.
 *
 * Allowlist (preferred over a blocklist so new keys are wiped by default):
 * - Tour flags (`tour.*:seen`, legacy `tour-shown`, `tours:migrated-from-legacy`) always persist.
 * - Chapter backups in localStorage (`escribonauta_<projectId>_<chapterId>` + metadata) persist when
 *   `keepChapterBackups` is true (default on all session ends; IndexedDB mirrors use the same policy).
 */
export function clearUserLocalStorage(options: { keepChapterBackups?: boolean } = {}) {
  const { keepChapterBackups = false } = options
  const keysToKeep: string[] = []

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key && isPersistedTourStorageKey(key)) {
      keysToKeep.push(key)
    } else if (key && keepChapterBackups && BackupService.isChapterBackupStorageKey(key)) {
      keysToKeep.push(key)
    }
  }

  const valuesToKeep = keysToKeep.map((key) => ({
    key,
    value: localStorage.getItem(key),
  }))

  localStorage.clear()

  valuesToKeep.forEach(({ key, value }) => {
    if (value !== null) {
      localStorage.setItem(key, value)
    }
  })
}
